import React, { FC, PropsWithChildren, useEffect } from "react";
import Header from "@components/Header/Header";
import SideBar from "@components/SideBar/SideBar";
import { Box, Stack } from "@mui/material";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";
import { useMediaQuery } from "react-responsive";
import MenuDrawer from "@components/MenuDrawer/MenuDrawer";
import { RootState } from "@store/store";
import { useDispatch, useSelector } from "react-redux";
import { Mode } from "@store/homeSlice";
import Footer from "@components/Footer/Footer";
import { setOpen } from "@store/sideBarSlice";
import SubscriptionExpiredAlert from "@components/SubscriptionExpiredAlert";
import { useScrollFix } from "@hooks/useScrollFix";
import { useLocation } from "react-router-dom";

const Content = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  gap: 20px;
`;

const SideBarPanelContainer = styled.div<{ compact: boolean }>`
  margin-left: 20px;
  width: ${(props) => (props.compact ? "64px" : "280px")};
  position: relative;
`;

const SideBarPanel = styled.div`
  position: fixed;
  top: 64px;
  left: 20px;
  z-index: 1;
  height: calc(100dvh - 94px);
  background-color: #f8f8f8;
  border-radius: 10px;
`;

const HomeLayout: FC<PropsWithChildren<any>> = ({ children }) => {
  const scrollRef = useScrollFix();
  const location = useLocation();
  const hideSidebar = location.pathname.startsWith("/patients/manage");
  const mode = useSelector((state: RootState) => state.home.mode);
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state: RootState) => state.drawer.open);

  useEffect(() => {
    if (drawerOpen === null) {
      dispatch(setOpen(!isSmScreen));
    }
  }, [drawerOpen, isSmScreen, dispatch]);

  return (
    <Box
      ref={scrollRef}
      flex={1}
      overflow="auto"
      display="flex"
      flexDirection="column"
    >
      <Header />
      <Box minHeight="64px" />
      <Content>
        {mode === Mode.Caregiver && !hideSidebar ? (
          <>
            {isSmScreen ? (
              <MenuDrawer />
            ) : (
              <SideBarPanelContainer compact={!drawerOpen}>
                <SideBarPanel>
                  <SideBar compact={!drawerOpen} />
                </SideBarPanel>
              </SideBarPanelContainer>
            )}
          </>
        ) : null}
        <Stack flex="1" width="100%">
          <SubscriptionExpiredAlert />
          {children}
        </Stack>
      </Content>
      <Footer />
    </Box>
  );
};

export default HomeLayout;
